var React = require('react');
var helpers = require('svg-react-loader/helpers')(require('react-dom'));

module.exports = React.createClass({

    displayName: "ShoppingCart",

    getDefaultProps () {
        return {"xmlns":"http://www.w3.org/2000/svg","className":"dibsvg-svg dibsvg-shopping-cart","viewBox":"-220.7 -160.7 500 500"};
    },

    componentDidMount () {
        helpers.applyXmlAttributes(this);
    },

    render () {
        var props = this.props;
        var children = props.children;

        return (
            <svg {...this.props}>
                  <path d="M263.2-67.5H-71.5c-8.9 0-16.1 7.6-16.1 16.9 0 .1-17.9-92.8-17.9-92.8-2.1-10.6-8.4-17.4-21.9-17.4h-77.1c-8.9 0-16.1 7.6-16.1 16.9 0 9.4 7.2 16.9 16.1 16.9h70.4l58.8 307.5c2.3 10.6 11.4 14.6 19.5 14.6H193c8.4 0 17-3.7 19.2-12.8l63.8-219c1.1-3.3 3.3-8.2 3.3-14 0-9.2-7.2-16.8-16.1-16.8zm-77.8 228.9H-47.3L-86.8-45.4c2.1 6.8 8.1 11.8 15.3 11.8h314.1l-57.2 195z"/>
  <path d="M-22.9 254.6c-23 0-41.6 19-41.6 42.4s18.6 42.4 41.6 42.4 41.6-19 41.6-42.4-18.6-42.4-41.6-42.4zm.3 57.9c-8.7 0-15.7-7-15.7-15.5 0-8.6 7-15.5 15.7-15.5s15.7 7 15.7 15.5-7 15.5-15.7 15.5z"/>
  <path d="M167.7 254.6c-22.7 0-41 19-41 42.4s18.4 42.4 41 42.4 41-19 41-42.4-18.3-42.4-41-42.4zm.1 57.9c-8.6 0-15.5-7-15.5-15.5 0-8.6 7-15.5 15.5-15.5 8.6 0 15.5 7 15.5 15.5s-6.9 15.5-15.5 15.5z"/>
                {React.Children.map(children, (c) => (c))}
            </svg>
        );
    }
});



// WEBPACK FOOTER //
// ./src/shopping-cart.svg